require('./bootstrap');

import Vue from 'vue'

import store from './store/index'

import vSelect from 'vue-select';

Vue.component('v-select', vSelect);

import 'vue-select/dist/vue-select.css';

import Toasted from 'vue-toasted';

Vue.use(Toasted);

const { EncryptStorage } = require('encrypt-storage');

const encryptStorage = new EncryptStorage('$2y$10$KqB2fi2qHO4EmPM40mc7jubbJT2pM4Sg02eZbG3t1fYKBUpMi1Klm', {
    prefix: '@google',
    storageType: 'localStorage',
});

Vue.prototype.$storage = encryptStorage
window.$storage = encryptStorage

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);

Vue.toasted.register('error',
    (payload) => {
        if (!payload.message) {
            return "Oups quelque chose c'est mal passé"
        }
        return "Oops.. " + payload.message;
    },
    {
        type: 'error',
        duration: 6000,
    }
)
Vue.toasted.register('all',
    (payload) => {
        if (!payload.message) {
            return "Opération effectuée"
        }
        return `${payload.message}`;
    },
    {
        type: 'success',
        duration: 6000,
    }
)

import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyCnNJtmWA1m6fDK9F9n_pREywLzY5mLsCo",
    authDomain: "nsia-e-commerce-e3a29.firebaseapp.com",
    projectId: "nsia-e-commerce-e3a29",
    storageBucket: "nsia-e-commerce-e3a29.appspot.com",
    messagingSenderId: "1063013772375",
    appId: "1:1063013772375:web:73082808c34439e9a70712",
    measurementId: "G-XDTQLY4119"
};

firebase.initializeApp(firebaseConfig);

var db = firebase.firestore();

window.db = db

db.settings({
    timestampsInSnapshots: true,
    merge: true
})

import { api, assets, router, format, uuidGen } from './helpers/shared'
window.api = api;
require('./mixins/settings');

Vue.component('admin-dashboard', require('./pages/admin/dashboard/index').default);
Vue.component('admin-users', require('./pages/admin/users/index').default);
Vue.component('api-users', require('./pages/admin/api/users/index').default);

Vue.component('admin-profile', require('./pages/admin/users/profile').default);
Vue.component('admin-customers', require('./pages/admin/users/customers').default);
Vue.component('admin-promo', require('./pages/admin/promo/index').default);
Vue.component('admin-subscription', require('./pages/admin/subscription/list').default);
Vue.component('me-subscription', require('./pages/admin/subscription/me').default);
Vue.component('admin-suggestion', require('./pages/admin/suggestion/index').default);
Vue.component('admin-suggestion-detail', require('./pages/admin/suggestion/detail').default);
Vue.component('admin-prospect', require('./pages/admin/prospect/list').default);
Vue.component('admin-prospect-detail', require('./pages/admin/prospect/detail').default);
Vue.component('admin-subscription-detail', require('./pages/admin/subscription/detail').default);
Vue.component('admin-subscription-me-detail', require('./pages/admin/subscription/detailMe').default);
Vue.component('admin-assurance-auto', require('./pages/admin/subscription/contrat/assAuto').default);
Vue.component('admin-assurance-cima', require('./pages/admin/subscription/contrat/assCima').default);
Vue.component('admin-assurance-incorporation', require('./pages/admin/subscription/contrat/assIncorporation').default);

Vue.component('admin-reporting', require('./pages/admin/reporting/list').default);
Vue.component('admin-settings', require('./pages/admin/settings/index').default);
Vue.component('admin-categorie-intermediaire', require('./pages/admin/CategorieIntermediaire/index').default);
Vue.component('admin-intermediaire', require('./pages/admin/intermediaire/index').default);
//Client

Vue.component('terms-app', require('./pages/terms/index').default);
Vue.component('subscription-wait', require('./pages/client/subscription/wait').default);
Vue.component('client-profile', require('./pages/client/profile/index').default);
Vue.component('voyage', require('./pages/assurance/voyage').default);
Vue.component('voyage-subscription', require('./pages/assurance/voyage-subscription').default);
Vue.component('habitation', require('./pages/assurance/apefa').default);
Vue.component('automobile', require('./pages/assurance/automobile').default);
Vue.component('basket', require('./pages/basket/index').default);
Vue.component('mdBasket', require('./pages/basket/mdLink').default);
Vue.component('basket-client', require('./pages/basket/clientBasket').default);
Vue.component('basket-client-lg', require('./pages/basket/clientBasketLg').default);
Vue.component('habitation-subscription', require('./pages/assurance/habitation-subscription').default);
Vue.component('auto-subscription', require('./pages/assurance/auto-subscription').default);
Vue.component('auto-subscription', require('./pages/assurance/auto-subscription').default);
Vue.component('pannier', require('./pages/basket/pannier').default);
Vue.component('client-subscription', require('./pages/client/subscription/list').default);
Vue.component('client-subscription-save', require('./pages/client/subscription/save').default);
Vue.component('home-page', require('./pages/home/index').default);
Vue.component('client-dashboard', require('./pages/client/dashboard/index').default);
Vue.component('suggestion', require('./pages/suggestion/index').default);
Vue.component('contact-form', require('./pages/contact/index').default);
Vue.component('burgger', require('./components/burgger/index').default);
Vue.component('checkOut', require('./pages/assurance/checkout').default);
Vue.component('client-subscription-detail', require('./pages/client/subscription/detail').default);
Vue.component('client-subscription-continous', require('./pages/client/subscription/continous').default);
Vue.component('subscription-promo', require('./pages/admin/promo/subscription').default);

Vue.component('intgest-subscription', require('./pages/intGest/subscription/list').default);
Vue.component('intgest-prospect', require('./pages/intGest/prospect/list').default);
Vue.component('intgest-prospect-detail', require('./pages/intGest/prospect/detail').default);
Vue.component('intgest-subscription-detail', require('./pages/intGest/subscription/detail').default);
Vue.component('intgest-profile', require('./pages/intGest/profile/index').default);

Vue.component('api-requests', require('./pages/admin/api/requests/index').default);

Vue.prototype.$assets = (...args) => assets(...args);
Vue.prototype.$router = (...args) => router(...args);
Vue.prototype.$document = (...args) => window.$(...args);
Vue.prototype.$routing = (...args) => api(...args);
Vue.prototype.$flatpickr = (...args) => flatpickr(...args);
Vue.prototype.$format = (...args) => format(...args);

Vue.prototype.$db = (...args) => db(...args);
Vue.prototype.$uuid = () => uuidGen();

Vue.prototype.$swal = window.Swal

// new Vue({
//     store,
//     el: '#app',
// });

new Vue({
    store
}).$mount('#app');
